import 'angular:locale/data:fr-CA';
import 'angular:locale/data:en-CA';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
